var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.95825,
    y: 4.49902,
    width: 10,
    height: 7.5,
    rx: 1.18403,
    stroke: "#111111",
    strokeWidth: 0.592014
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.95825 6.37402L7.42874 8.60927C7.76207 8.77593 8.15443 8.77594 8.48776 8.60927L12.9583 6.37402",
    stroke: "#111111",
    strokeWidth: 0.592014
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageLight);
export default __webpack_public_path__ + "static/media/Message_light.eb5926d2fcfeab80730a253f85cb7173.svg";
export { ForwardRef as ReactComponent };